import { useLazyQuery } from '@apollo/client';

import { CustomerFilterInput, CustomerOutput } from '@/graphql/contracts/_generated_/contracts';
import { GetCustomers, GetCustomersVariables } from '@/graphql/contracts/_generated_/getCustomers.query';
import { PaginatedFilteredGridData } from '@/utils/data-helpers/PaginatedFilteredGridData';
import GetCustomersQuery from '@/graphql/contracts/getCustomers.query.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';

export type PaginatedFilteredCustomers = PaginatedFilteredGridData<CustomerFilterInput>;
export type CustomerOutputWithId = CustomerOutput & {
  id: string;
};

export default function useGetCustomers() {
  const [_getCustomers, { loading, error }] = useLazyQuery<GetCustomers, GetCustomersVariables>(
    GetCustomersQuery,
    {
      client: apolloClientContracts,
      fetchPolicy: 'network-only',
      onError: (err) =>
        notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger',
        }),
    },
  );

  const getCustomers = async (dto: PaginatedFilteredCustomers) => {
    const customers = await _getCustomers({
      variables: {
        ...(dto as GetCustomersVariables),
      },
    });

    return customers.data?.customerGrid?.masterRecords?.customers;
  };

  return {
    getCustomers,
    isLoadingGetCustomers: loading,
    error,
  } as const;
}
